import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Theme } from 'src/app/theme/theme';
import { UserInfo } from '../../user-info';
import { UserService } from '../../user/user.service';
import { Gift } from '../gift';
import { GiftService } from '../gift.service';

export interface SendGiftDialogData {
  userInfo: UserInfo;
  theme: Theme;
}

@Component({
  selector: 'app-send-gift-dialog',
  templateUrl: './send-gift-dialog.component.html',
  styleUrls: ['./send-gift-dialog.component.scss'],
  standalone: false
})
export class SendGiftDialogComponent implements OnInit {
  private dialogRef = inject<MatDialogRef<SendGiftDialogComponent>>(MatDialogRef);
  data = inject<SendGiftDialogData>(MAT_DIALOG_DATA);
  private giftService = inject(GiftService);
  private userService = inject(UserService);

  gifts: Gift[];
  selectedGiftId: string;
  isLoadingGift = false;
  isSending = false;
  error?: string;

  ngOnInit(): void {
    this.isLoadingGift = true;
    this.giftService.getGifts().subscribe((gifts) => {
      this.isLoadingGift = false;
      this.gifts = gifts;
    });
  }

  select(id: string): void {
    this.selectedGiftId = id;
  }

  submit(): void {
    this.error = null;
    if (!this.selectedGiftId) {
      this.error = 'กรุณาเลือกของขวัญ';
    } else {
      this.isSending = true;
      this.userService.sendGift(this.selectedGiftId, this.data.userInfo.id).subscribe({
        next: () => {
          this.isSending = false;
          this.userService.updateCurrentUser();
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isSending = false;
          this.error = err?.error?.message;
        }
      });
    }
  }

  get userInfo(): UserInfo {
    return this.userService.userInfo;
  }

  get headerStyle() {
    return {
      'background-color': this.data.theme.primaryColor
    };
  }
}
